<template>
  <div>
    <div class="container-row">
      <div class="speaker-search-filter-wrap">
        <div class="speaker-search-filter">
          <input type="text" placeholder="Search Speakers" v-model="searchQuery" id="speakersearch" />
        </div>
        <div class="multi-filter-col multi-filter-col-large primary-filter hide-filter" ref="primaryFilter">
          <div class="multi-filter-body">
            <div class="custom-filter-head " @click.stop="togglePrimaryfilter()">
              <span>Conference Program</span>
              <svg :class="{ rotate: isPrimaryfilterExpanded }" fill="#000000" viewBox="0 0 32 32">
                <path
                  d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z">
                </path>
              </svg>
            </div>
            <div class="custom-filter-contant" :class="{ expanded: isPrimaryfilterExpanded }">
              <ul>
                <li v-for="(category, index) in allSessionCategories" :key="index">
                  <label class="multi-filter-selector">{{ category }}
                    <input type="checkbox" class="multi-filter-checkbox" :value="category"
                      v-model="selectedSessionCategories" />
                    <span class="multi-filter-checkmark"></span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="multi-filter-col secondary-filter">
          <div class="multi-filter-body">
            <button @click.stop="resetFilters()">Reset</button>
          </div>
        </div>
      </div>
      <div class="four-col-wrap">
        <template v-if="!loader">
          <template v-for="speaker in filteredSpeakers">
            <div class="speaker-profile" v-if="
              speaker.avatar &&
              speaker.avatar != 'https://www.dmgeventsconferences.com/'
            " v-bind:key="speaker.id">
              <div class="speaker-profile-outer">
                <div class="speaker-img">
                  <img v-if="speaker.avatar == null || speaker.avatar == ''"
                    src="https://www.futureenergyasia.com/media/7674/speaker-default.jpg?width=224&height=224&mode=crop"
                    alt="" />
                  <img class="img-fluid" v-else :srcset="speaker.avatar + '?width=224&height=224&mode=crop'" />
                </div>
                <div class="desc">
                  <h6>{{ speaker.name }}</h6>
                  <p>
                    {{ speaker.jobTitle }}
                  </p>
                  <p class="company">{{ speaker.company }}</p>
                </div>
              </div>
              <router-link :to="{
                name: 'SpeakerDetails',
                query: { userId: speaker.apiId }, 
              }" v-slot="{ href, navigate }">
                <div class="desc-btn">
                  <div class="btn-primary">
                    <a :href="href" @click="navigate" target="_blank">View profile</a>
                  </div>
                </div>
              </router-link>
            </div>
          </template>
        </template>
        <div class="loader-wrapper" v-if="loader">
          <div class="loader"></div>
        </div>
      </div>
    </div>

    <div class="speaker-container clearfix">
      <div class="speaker-pop" v-for="speaker in speakerList" v-bind:key="speaker.id">
        <router-link :to="{
          name: 'SpeakerDetails',
          query: { userId: speaker.apiId },
          hash: '#top',
        }">
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorList",
  data() {
    return {
      speakerList: [],
      searchQuery: "",
      loader: false,
      selectedSessionCategories: [],
      allSessionCategories: [],
      isPrimaryfilterExpanded: false,
      sessionType: "",
      strategicFilters: [
        "Strategic Leadership",
        "Climatetech & AI",
        "Hydrogen",
        "Diversity, Equity & Inclusion in Energy",
        "Future Leaders",
      ],
      technicalFilters: [
        "Climatetech & AI",
        "Hydrogen",
        "Shipping & Marine",
        "Commercial",
        "EPC & Gas Processing",
      ],
    };
  },
  computed: {
    filteredSpeakers() {
      return this.speakerList.filter((speaker) => {
        return (
          (speaker.name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
            speaker.company
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase())) &&
          (this.selectedSessionCategories.length === 0 ||
            (speaker.session_categories &&
              this.selectedSessionCategories.some((category) =>
                speaker.session_categories.includes(category)
              )))
        );
      });
    },
  },
  beforeDestroy() {
    // Remove event listener when the component is destroyed
    document.removeEventListener("click", this.handleOutsideClick);
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
    //debugger
    const url = window.location.href;
    const domain = url.split("/")[2];
    console.log(domain);
    if (domain === "www.futureenergyasia.com") {
      this.eventname = "fma";
    } else if (domain === "www.future-mobility.asia") {
      this.eventname = "fma";
    } else if (domain === "www.japanenergyevent.com") {
      this.eventname = "japan";
    } else if (domain === "www.gastechevent.com") {
      this.eventname = "gastech";
    } else if (domain === "www.worldlngsummit.com") {
      this.eventname = "worldlng";
    } else {
      this.eventname = "worldlng";
    }

    //Checking event name
    console.log("Event name:", this.eventname);
    console.log('Selected Session Categories:', this.selectedSessionCategories);
    console.log('All Session Categories:', this.allSessionCategories);
    //test code end 

    const pathname = window.location.pathname;
    if (pathname.includes("renewable-fuels-conference")) {
      this.type = "Renewable Fuels Conference";
    } else {
      this.type = "";
    }

    //Checking type
  
    if (pathname.includes ("renewable-fuels-conference")) {
    
      this.getAllSpeakerList(this.eventname,this.type);

    }
    else {
      this.getAllSpeakerList(this.eventname);
    }
    
  },
  methods: {
    getAllSpeakerList(eventname, type) {
      this.loader = true;

      axios
        .get(url.category_list_api(eventname, type))
        .then((response) => {


          // Sort the speaker list by name in alphabetical order
          if (type === "Technical") {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
          }
          this.speakerList = response.data;
          // let categories = new Set();
          // this.speakerList.forEach((speaker) => {
          //   if (speaker.session_categories) {
          //     speaker.session_categories
          //       .split(", ")
          //       .forEach((category) => categories.add(category.trim()));
          //   }
          // });
          // this.allSessionCategories = Array.from(categories);
          this.allSessionCategories =
            type === "Strategic"
              ? this.strategicFilters
              : this.technicalFilters;
        })
        .catch((err) => {
          console.log(err.response);
        })
        .finally(() => {
          setTimeout(() => {
            this.loader = false;
          }, 3000);
        });
    },
    togglePrimaryfilter() {
      this.isPrimaryfilterExpanded = !this.isPrimaryfilterExpanded;
    },
    resetFilters() {
      this.selectedSessionCategories = [];
      this.isPrimaryfilterExpanded = false;
    },
    handleOutsideClick(e) {
      // Check if the click is outside the primary filter
      if (
        this.isPrimaryfilterExpanded &&
        !this.$refs.primaryFilter.contains(e.target)
      ) {
        this.togglePrimaryfilter();
      }
    },
  },
};
</script>
<style>
#options .option-combo ul {
  margin: 0;
  display: inline-block;
  width: calc(100% - 200px);
}

img.filter-block-logo {
  max-width: 150px;
  width: 100%;
}

.subject-outer p {
  font-size: 15px;
}

.wrap-programme {
  padding: 40px 0 0;
}

.date-filter-block {
  display: flex;
  align-items: center;
}

.sub-sp-block {
  width: 80%;
}

@media (max-width: 1199px) {
  .date-filter-block {
    display: block;
  }

  img.filter-block-logo {
    display: block;
    margin: 0 auto 20px !important;
    max-width: 200px;
  }

  #options .option-combo ul {
    width: 100%;
  }

  .active {
    display: block;
  }
}
</style>
